import { LOGIN_USER, LOGOUT_USER } from './types'

export default {
  [LOGIN_USER] (state, payload) {
  //   state.codigo = payload.user.codigo
  //   state.email = payload.user.email
  //   state.origem = payload.user.origem
  //   state.username = payload.user.username
  //   state.perfis = payload.perfis
  //   state.isLogged = true
  //   state.initialized = true
  },

  [LOGOUT_USER] (state) {
   // state.user = {}
   // state.isLogged = false
   // state.initialized = false
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js